import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { STATUS_STYLES } from '../tokens'

const useStyles = makeStyles({
  root: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '999px',
    fontSize: '11px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
})

/** "Published" / "Draft" pill. */
const StatusPill = ({ status, className, style }) => {
  const classes = useStyles()

  return (
    <span
      className={`${classes.root} ${className || ''}`}
      style={{ ...(STATUS_STYLES[status] || STATUS_STYLES.Draft), ...style }}
    >
      {status}
    </span>
  )
}

export default StatusPill
